import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { KTSVG } from "../../../smallnation/helpers"
import { PageTitle } from "../../../smallnation/layout/core"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
import moment from "moment";
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { set, useForm } from "react-hook-form";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"
const Option = (props) => {
  return (
      <div>
          {
              //console.log("results=="+JSON.stringify(props))
          }
          <components.Option {...props}>
              <input
                  type="checkbox"
                  checked={props.isSelected}
                  onChange={() => null}
              />{" "}
              <label>{props.label}</label>
          </components.Option>
      </div>
  );
};



const JobsReport: FC = () => {
      const intl = useIntl()
      const red = "red";
      const ITEMS_PER_PAGE = 50; // Per page show the data pagination
      const [totalItems, setTotalItems] = useState(0);
      const [totalpages, settotalPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(1);
      const [jobfilterlist, setJobFilterList] = useState([]);
      const [locationCounty, setLocationCounty] = useState([]);
  const [jobTypes, setJobType] = useState([]);
  const [educations, setEducations] = useState([]);
  const [categories, setCategory] = useState([]);
  const [muljobTypes, setMulJobTypes] = useState([]);
  const [optionSelected_d, setoptionSelectedd] = useState(null);
  const [jobtypeRequestArray_d, setJobTypeRequestArrayd] = useState([]);
  const [muleducation, setMulEducationTypes] = useState([]);
  const [eduRequestArray_d, setEduTypeRequestArrayd] = useState([]);
  const [optionEduSelected_d, setoptionEduSelectedd] = useState(null);
  const [mullocationCounty, setMulLocationCounty] = useState([]);
  const [mullocationCountyselected_d, setMulLocationCountyOptionSelectedd] = useState([]);
  const [locationRequestArray_d, setLocationRequestArrayd] = useState([]);
  const [mulcategories_d, setMulCategory_d] = useState([]);
  const [industryRequestArray_d, setIndustryRequestArrayd] = useState([]);
  const [optionCatSelected_d, setoptionCatSelectedd] = useState(null);
  const [statusses, setStatus] = useState([]);
  const [mulstatus_d, setMulStatus_d] = useState([]);
  const [statusRequestArray_d, setStatusRequestArrayd] = useState([]);
  const [optionStatSelected_d, setoptionStatSelectedd] = useState(null);
  const [careers, setCareer] = useState([]);
  const [mulcareer_d, setMulCareers_d] = useState([]);
  const [careerRequestArray_d, setCareerRequestArrayd] = useState([]);
  const [optionCareerSelected_d, setoptionCareerSelectedd] = useState(null);
  const [educationRequestArray_d, setEducationRequestArrayd] = useState([]);
  const [optionEducationSelected_d, setoptionEducationSelectedd] = useState(null);
  const [rangeFromDate, setFromDate] = useState(new Date());
  const [rangeToDate, setToDate] = useState(new Date());
  const [jobShareURL, setJobShareURL] = useState('');
  const [reportRangeFrom, setReportRangeFrom] = useState('');
  const [reportRangeTo, setReportRangeTo] = useState('');
  const [reportStatus, setReportStatus] = useState('');
  const [reportIndustry, setReportIndustry] = useState('');
  const [reportLocation, setReportLocation] = useState('');
  const [reportJobtype, setReportJobtype] = useState('');
  const [reportEducation, setReportEducation] = useState('');
  const [reportCareer, setReportCareer] = useState('');
  const [runReport, setRunReport] = useState(0);

  var FileSaver = require('file-saver');

  var industry_webvar = [];
    var location_webvar = [];
    var jobtype_webvar = [];
    var education_webvar = [];
    var status_webvar = [];
    var career_webvar = [];


      const {
        register,
        formState: { errors },
        handleSubmit
      } = useForm({
        criteriaMode: "all", mode: "onBlur"
      });

      const handleChangeForCate_d = (selected) => {
        //alert();
        var dummArray = [];
        var dummArray_label = '';
        for (var i = 0; i < selected.length; i++) {
            //alert(selected[i].label.toString());
            dummArray.push(selected[i].value.toString());
            if(i==0){
              dummArray_label = selected[i].label.toString();
            } else{
              dummArray_label = dummArray_label+', '+selected[i].label.toString();
            }
            industry_webvar.push(selected[i].value.toString());
        }
        setIndustryRequestArrayd(dummArray);
        //industry_webvar = dummArray;
        $('#industry_selected').val(JSON.stringify(dummArray));
        $('#industry_selfilter').val(dummArray_label);
        setoptionCatSelectedd(selected);
        setReportIndustry(dummArray_label);
    };

    function triggerdateclick(){
      /*var fromdate = $('#from_datepic').val();
      //var monthf = parseInt(today.getMonth()+1);
      var monthf = ("0" + fromdate.getMonth()).slice(-2);
      //var datef = today.getDate();
      var datef = ("0" + fromdate.getDate()).slice(-2);
      var yearf = fromdate.getFullYear();
      $('#from_date').val(yearf+'-'+monthf+'-'+datef); */
      $('#from_datepic').click();
    }

    function triggerdateclick_to(){
      /*var todate = $('#to_datepic').val();
      //var monthf = parseInt(today.getMonth()+1);
      var montht = ("0" + todate.getMonth()).slice(-2);
      //var datef = today.getDate();
      var datet = ("0" + todate.getDate()).slice(-2);
      var yeart = todate.getFullYear();
      $('#to_date').val(yeart+'-'+montht+'-'+datet); */
      $('#to_datepic').click();
    }

    const handleChangeForstat_d = (selected) => {
      //alert();
      var dummArray = [];
      var dummArray_label = '';
      for (var i = 0; i < selected.length; i++) {
          //alert(selected[i].label.toString());
          dummArray.push(selected[i].value.toString());
          if(i==0){
            dummArray_label = selected[i].label.toString();
          } else{
            dummArray_label = dummArray_label+', '+selected[i].label.toString();
          }

          status_webvar.push(selected[i].value.toString());
      }
      setStatusRequestArrayd(dummArray);
      //industry_webvar = dummArray;
      $('#status_selected').val(JSON.stringify(dummArray));
      $('#status_selfilter').val(dummArray_label);
      setoptionStatSelectedd(selected);
      setReportStatus(dummArray_label);
  };

  const handleChangeForcareer_d = (selected) => {
    //alert();
    var dummArray = [];
    var dummArray_label = '';
    for (var i = 0; i < selected.length; i++) {
        //alert(selected[i].label.toString());
        dummArray.push(selected[i].value.toString());
        if(i==0){
          dummArray_label = selected[i].label.toString();
        }
        else{
          dummArray_label = dummArray_label+', '+selected[i].label.toString();
        }
        career_webvar.push(selected[i].value.toString());
    }
    setCareerRequestArrayd(dummArray);
    //industry_webvar = dummArray;
    $('#career_selected').val(JSON.stringify(dummArray));
    $('#Career_selfilter').val(dummArray_label);
    setoptionCareerSelectedd(selected);
    setReportCareer(dummArray_label);
};

      const handleChange_d = (selected) => {
        var dummArray = [];
        var dummArray_label = '';
        console.log(selected);
        for (var i = 0; i < selected.length; i++) {
            dummArray.push(selected[i].value.toString());
            if(i==0){
              dummArray_label = selected[i].label.toString();
            }
            else{
              dummArray_label = dummArray_label+', '+selected[i].label.toString();
            }
            jobtype_webvar.push(selected[i].value.toString());
        }
        console.log(dummArray);
        setoptionSelectedd(selected);
        //jobtype_webvar = dummArray;
        $('#jobtype_selected').val(JSON.stringify(dummArray));
        $('#jobtype_selfilter').val(dummArray_label);
        //$('#jobtypeLabel_selected').val(JSON.stringify(dummArray_label));
        setJobTypeRequestArrayd(dummArray);
        setReportJobtype(dummArray_label);
    };

    const handleChangeForLocation_d = (selected) => {
      var dummArray = [];
      var dummArray_label = '';
      for (var i = 0; i < selected.length; i++) {
          dummArray.push(selected[i].value.toString());
          if(i==0){
            dummArray_label = selected[i].label.toString();
          }
          else{
            dummArray_label = dummArray_label+', '+selected[i].label.toString();
          }
          location_webvar.push(selected[i].value.toString());
      }
      setMulLocationCountyOptionSelectedd(selected);
      //location_webvar = dummArray;
      $('#location_selected').val(JSON.stringify(dummArray));
      $('#location_selfilter').val(dummArray_label);
      setLocationRequestArrayd(dummArray);
      setReportLocation(dummArray_label);

  };

      useEffect(() =>
      {
        getIndustryData();
        getStatusData();
        getCareerData();
        set_daterange();
        $(".load-wrap").hide();
        $('#datepick_from').hide();
          $('#datepick_to').hide();
          $('#dateValidMsg').hide();
          $('#from_date').show();
          $('#to_date').show();

          var today = new Date();
          var monthf = ("0" + (today.getMonth() + 1)).slice(-2);
          var datef = ("0" + today.getDate()).slice(-2);
          var yearf = today.getFullYear();
          //$('#to_date').val(monthf+'/'+datef+'/'+yearf);
          setReportRangeTo(monthf+'/'+datef+'/'+yearf);

          var newDate = new Date(today.setMonth(today.getMonth()-1));
          var montht = ("0" + (newDate.getMonth() + 1)).slice(-2)
          var datet = ("0" + newDate.getDate()).slice(-2);
          var yeart = newDate.getFullYear();
          //$('#from_date').val(montht+'/'+datet+'/'+yeart);
          setReportRangeFrom(montht+'/'+datet+'/'+yeart);

        services.getLocationCounty().then((res) => {
          console.log("##################433");
          console.log(JSON.stringify(res));
          setLocationCounty(res.data.content);
          // alert(res.data.content.length)
          var dummArray = [];
          for (var i = 0; i < res.data.content.length; i++) {
              dummArray.push({ "label": res.data.content[i].name, "value": res.data.content[i].jobLocationCountyId })
          }
          setMulLocationCounty(dummArray)
      });


        services.getJobType().then((res) => {
        /* console.log("setJobType data=" + JSON.stringify(res.data));
          setJobType(res.data.content); */

          var jobtype_unsort = res.data.content;
          var jobtypes_sorted = jobtype_unsort.sort((a, b) => b.jobTypeId - a.jobTypeId);
          array_move(jobtypes_sorted, 0, (jobtypes_sorted.length-1));
          jobtypes_sorted = jobtypes_sorted.filter(function (elem) {
            return elem.name !== 'Continuing Education';
          });
          setJobType(jobtypes_sorted);
          var dummArray = [];
            for (var i = 0; i < jobtypes_sorted.length; i++) {
                dummArray.push({ "label": jobtypes_sorted[i].name, "value": jobtypes_sorted[i].jobTypeId })
            }
            setMulJobTypes(dummArray)

        });
        services.getEducation().then((res) => {
          //console.log("getEducation data=" + JSON.stringify(res.data));
          setEducations(res.data.content);
          var dummArray = [];
          for (var i = 0; i < res.data.content.length; i++) {
              dummArray.push({ "label": res.data.content[i].name, "value": res.data.content[i].educationId })
          }
          setMulEducationTypes(dummArray)

      });
        //getjobslist(ITEMS_PER_PAGE,'1');

        $(function(){
          $(".new-scrl-tbl").scroll(function(){
            $(".new-scrl-tbl2").scrollLeft($(".new-scrl-tbl").scrollLeft());
          });
          $(".new-scrl-tbl2").scroll(function(){
            $(".new-scrl-tbl").scrollLeft($(".new-scrl-tbl2").scrollLeft());
          });
        });

      },[]);

      function array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; // for testing
    };

    function set_daterange(){
        var rangeval:any = $('#created_range').val();
        if(rangeval == 'custom'){
          $('#datepick_from').show();
          $('#datepick_to').show();
          $('#from_date').hide();
          $('#to_date').hide();
        }
        else{
          $('#datepick_from').hide();
          $('#datepick_to').hide();
          $('#from_date').show();
          $('#to_date').show();
                var today = new Date();
                //var monthf = parseInt(today.getMonth()+1);
                var monthf = ("0" + (today.getMonth() + 1)).slice(-2);
                //var datef = today.getDate();
                var datef = ("0" + today.getDate()).slice(-2);
                var yearf = today.getFullYear();
                $('#to_date').val(monthf+'/'+datef+'/'+yearf);

                var newDate = new Date(today.setMonth(today.getMonth()-rangeval));
                //var montht = parseInt(newDate.getMonth()+1);
                var montht = ("0" + (newDate.getMonth() + 1)).slice(-2)
                //var datet = newDate.getDate();
                var datet = ("0" + newDate.getDate()).slice(-2);
                var yeart = newDate.getFullYear();
                $('#from_date').val(montht+'/'+datet+'/'+yeart);
        }
    }

      const getIndustryData = () => {
        services.getIndustryData().then((res) => {
          setCategory(res.data.content);
          var dummArray = [];
          for (var i = 0; i < res.data.content.length; i++) {
              dummArray.push({ "label": res.data.content[i].name, "value": res.data.content[i].catId })
          }
          setMulCategory_d(dummArray)
      });
      }

      const getStatusData = () => {
        var status_ar = {"content":[{"statId":"published","name":"Published"},{"statId":"pending","name":"Pending"},{"statId":"filled","name":"Filled"},{"statId":"expired","name":"Expired"}],"pageable":{"sort":{"sorted":true,"unsorted":false,"empty":false},"pageNumber":0,"pageSize":2000,"offset":0,"paged":true,"unpaged":false},"totalElements":4,"totalPages":1,"last":true,"sort":{"sorted":true,"unsorted":false,"empty":false},"numberOfElements":4,"first":true,"size":2000,"number":0,"empty":false}
          setStatus(status_ar.content);
          var dummArray = [];
          for (var i = 0; i < status_ar.content.length; i++) {
              dummArray.push({ "label": status_ar.content[i].name, "value": status_ar.content[i].statId })
          }
          setMulStatus_d(dummArray)

      }

      const getCareerData = () => {
        var career_ar = {"content":[{"careerId":"Entry-Level","name":"Entry-Level"},{"careerId":"Mid-Level","name":"Mid-Level"},{"careerId":"Management/Supervisor","name":"Management/Supervisor"},{"careerId":"Executive-Level","name":"Executive-Level"}],"pageable":{"sort":{"sorted":true,"unsorted":false,"empty":false},"pageNumber":0,"pageSize":2000,"offset":0,"paged":true,"unpaged":false},"totalElements":4,"totalPages":1,"last":true,"sort":{"sorted":true,"unsorted":false,"empty":false},"numberOfElements":4,"first":true,"size":2000,"number":0,"empty":false}
          setCareer(career_ar.content);
          var dummArray = [];
          for (var i = 0; i < career_ar.content.length; i++) {
              dummArray.push({ "label": career_ar.content[i].name, "value": career_ar.content[i].careerId })
          }
          setMulCareers_d(dummArray)

      }

      const submitValue = () => {
        getjobslist(ITEMS_PER_PAGE,'1');
      }
      const searchList = () => {
       getjobslist(ITEMS_PER_PAGE,'1');
      }

      const handlePageChange2 = (offset,triggerevent) => {
        getjobslist(ITEMS_PER_PAGE,offset);
      };

      function validateCheck() {

      }



      const handleChangeForEdu_d = (selected) => {

          var dummArray = [];
          var dummArray_label = '';
          for (var i = 0; i < selected.length; i++) {
              //alert(selected[i].label.toString());
              dummArray.push(selected[i].value.toString());
              if(i==0){
                dummArray_label = selected[i].label.toString();
              }
              else{
                dummArray_label = dummArray_label+', '+selected[i].label.toString();
              }
              education_webvar.push(selected[i].value.toString());
          }
          setEducationRequestArrayd(dummArray);
          //industry_webvar = dummArray;
          $('#education_selected').val(JSON.stringify(dummArray));
          $('#education_selfilter').val(dummArray_label);
          setoptionEducationSelectedd(selected);
          setReportEducation(dummArray_label);
    };

    const filterContent_full = () => {
      var validateEditorTxt = 1;
      var industries_filter:any = [];
      var selected_ind:any = $('#industry_selected').val();
      if (selected_ind != '') {
          industries_filter = JSON.parse(selected_ind);
      }

      var status_filter:any = [];
      var selected_stat:any = $('#status_selected').val();
      if (selected_stat != '') {
          status_filter = JSON.parse(selected_stat);
      }

      var career_filter = [];
      var selected_career:any = $('#career_selected').val();
      if (selected_career != '') {
          career_filter = JSON.parse(selected_career);
      }

      var locations_filter:any = [];
      var selected_loc:any = $('#location_selected').val();
      if (selected_loc != '') {
          locations_filter = JSON.parse(selected_loc);
      }

      var educations_filter = [];
      var selected_edu:any = $('#education_selected').val();
      if (selected_edu != '') {
          educations_filter = JSON.parse(selected_edu);
      }

      var jobtypes_filter:any = [];
      var selected_types:any = $('#jobtype_selected').val();
      if (selected_types != '') {
          jobtypes_filter = JSON.parse(selected_types);
      }

      if($('#created_range').val() == 'custom'){
        var from_date_in:any = $('#from_datepic').val();
        var range_from = new Date(from_date_in);
        var to_date_in:any = $('#to_datepic').val();
        var range_to = new Date(to_date_in);
    }
    else {
      var from_dt1:any = $('#from_date').val();
      var range_from = new Date(from_dt1);
      var to_dt1:any = $('#to_date').val();
      var range_to = new Date(to_dt1);
    }

    var fmonth = ("0" + (range_from.getMonth() + 1)).slice(-2);
    var fdate = ("0" + range_from.getDate()).slice(-2);
    var fyear = range_from.getFullYear();
    var from = fyear+'-'+fmonth+'-'+fdate;
    $('#rangefromhid').val(fmonth+'/'+fdate+'/'+fyear);

    var tmonth = ("0" + (range_to.getMonth() + 1)).slice(-2);
    var tdate = ("0" + range_to.getDate()).slice(-2);
    var tyear = range_to.getFullYear();
    var to = tyear+'-'+tmonth+'-'+tdate;
    $('#rangetohid').val(tmonth+'/'+tdate+'/'+tyear);

    if(new Date(range_from) > new Date(range_to)){
      $("#dateValidMsg").show();
      $(window).scrollTop($('#dateValidMsg').position().top);
      validateEditorTxt = 0;
    }else{
      $("#dateValidMsg").hide();
    }

    if(validateEditorTxt == 0){
      return false;
     }

var rfhid:any = $('#rangefromhid').val();
var rohid:any = $('#rangetohid').val();
 setReportRangeFrom(rfhid);
 setReportRangeTo(rohid);
 //setReportStatus($('#status_selfilter').val());
 //setReportIndustry($('#industry_selfilter').val());
 //setReportLocation($('#location_selfilter').val());
 //setReportJobtype($('#jobtype_selfilter').val());
 //setReportEducation($('#education_selfilter').val());
 //setReportCareer($('#Career_selfilter').val());

      const requestObject = {
        "jobCategory": industries_filter,
        "jobLocation": locations_filter,
        "jobEducation": educations_filter,
        "jobType": jobtypes_filter,
        "pageSize": 50000,
        "pageNumber": 1,
        "sortBy": "createdOn",
        "sortDir": "asc",
        "siteId": 2,
        "searchTxt":$('#job_title').val(),
        "jobStatus":status_filter,
        "careerLevel":career_filter,
        "fromDate" : from,
        "toDate" : to

      }

      var accessTokenIn = sessionStorage.getItem("adminAccToken");
      const requestOptions = {
        method: 'POST',
       // timeout: '12000',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer "+accessTokenIn
          //'Authorization': accessTokenIn
        },
        body: JSON.stringify(requestObject)
      };

     $(".load-wrap").show();
      services.getJobReportListTime(requestOptions).then((res) => {
        //alert('res1');
        try{
          console.log(JSON.stringify(res.content));
          if (res.content) {
            //alert('res');
                var contAr = res.content;
                  download_excel(contAr);
           }
        }
        catch(ex){
          console.log('exception - '+ex);
        }
        
      });
  }

  function download_excel(profileListFull){
    var today = new Date();
    var month = today.toLocaleString('en-US', {month: 'short'});
    var date= today.getDate();
    var year = today.getFullYear();

    var filename = "Jobs-export-"+month+"-"+date+"-"+year+".csv";
    let csv = '';
    let row = '';
    let headers = '';

var row2='';
if(reportRangeTo != ''){
  row2 = row2+'Report Range From : '+reportRangeFrom+' To : '+reportRangeTo;
}
    

    if(reportRangeTo != '' && reportStatus != '')
        row2 = row2+';      ';

    if (reportStatus != '') 
        row2 = row2+'Status : '+reportStatus.replace(/,/g, "-");

    if(reportStatus != '' && reportIndustry != '')
        row2 = row2+';      ';   

    if (reportIndustry != '') 
        row2 = row2+'Industry : '+reportIndustry.replace(/,/g, "-");

    if(reportIndustry != '' && reportLocation != '')
        row2 = row2+';      ';    

    if (reportLocation != '') 
        row2 = row2+'County : '+reportLocation.replace(/,/g, "-");

    if(reportLocation != '' && reportJobtype != '')
        row2 = row2+';      ';    

    if (reportJobtype != '') 
        row2 = row2+'Type : '+reportJobtype.replace(/,/g, "-");

    if(reportJobtype != '' && reportEducation != '')
        row2 = row2+';      ';  

    if (reportEducation != '') 
        row2 = row2+'Education : '+reportEducation.replace(/,/g, "-");

    if(reportEducation != '' && reportCareer != '')
        row2 = row2+';      ';      

    if (reportCareer != '') 
        row2 = row2+'Career : '+reportCareer.replace(/,/g, "-");

    var jobtypeslisthead = 'Jobs Report'+',';
    var jobtypeslisthead = jobtypeslisthead+'\n'+row2+',';
   var jobtypeslisthead = jobtypeslisthead+'\n'+'Title'+','+'Company'+','+'Location'+','+'Type'+','+'Posted Date'+','+'Career Level'+','+'Education Level'+','+'Status'+','+'Job URL'+',';

    headers = headers.concat(jobtypeslisthead);
    csv = csv.concat(headers);
    row = '';

    for(var i=0; i<profileListFull.length; i++){
        var cats = profileListFull[i].categoryName;
        var jobtypenames = profileListFull[i].jobTypeName;
        var dateUpdated = new Date(profileListFull[i].createdDate);

    var fmonth = ("0" + (dateUpdated.getMonth() + 1)).slice(-2);
    var fdate = ("0" + dateUpdated.getDate()).slice(-2);
    var fyear = dateUpdated.getFullYear();

            //var displayupdated =  dateUpdated.toLocaleString("en-US");
            //displayupdated = displayupdated.replace(/-/g, "/");

          var displayupdated =  fmonth+'/'+fdate+'/'+fyear;

            var jobtypeslistrow = "";

          if(profileListFull[i].status == 'published'){
            var applyurl = process.env.React_App_PUBLIC_URL+"jobsummary?jobId="+profileListFull[i].jobId;
          }
          else{
            var applyurl = '--';
          }

          var jobTitle = profileListFull[i].jobTitle;
          jobTitle = jobTitle.replace(/,/g, ";");

          var companyName = profileListFull[i].companyName;
          companyName = companyName.replace(/,/g, ";");

          var city = profileListFull[i].city;
          city = city.replace(/,/g, ";");

          var state = profileListFull[i].state;
          state = state.replace(/,/g, ";");

var educationName = '';
try{
  if(profileListFull[i].educationName){
    educationName = profileListFull[i].educationName;
    console.log(educationName);
    if(educationName != ''){
      educationName = educationName.replace(/,/g, ";");
    }
 }
} 
catch(ex){

}

var career = '';
try{
  if(profileListFull[i].career){
    career = profileListFull[i].career;
    if(career != ''){
      career = career.replace(/,/g, ";");
    }
 }
} 
catch(ex){

}
         

           jobtypeslistrow = "\n"+jobTitle+','+companyName+", "+city+'-'+state+','+profileListFull[i].jobTypeName+','+displayupdated+','+career+','+educationName+','+profileListFull[i].status+','+applyurl+',';

        row = row.concat(jobtypeslistrow);
    }
    csv = csv.concat(row);

    var file = new File([csv], filename, {type: "application/csv"});
    FileSaver.saveAs(file);
    $(".load-wrap").hide();
}

      const getjobslist = (ITEMS_PER_PAGE,pageNumber) => {
        var validateEditorTxt = 1;
        var industries_filter:any = [];
        var selected_ind:any = $('#industry_selected').val();
        if (selected_ind != '') {
            industries_filter = JSON.parse(selected_ind);
        }

        var status_filter:any = [];
        var selected_stat:any = $('#status_selected').val();
        if (selected_stat != '') {
            status_filter = JSON.parse(selected_stat);
        }

        var career_filter:any = [];
        var selected_career:any = $('#career_selected').val();
        if (selected_career != '') {
            career_filter = JSON.parse(selected_career);
        }

        var locations_filter:any = [];
        var selected_loc:any = $('#location_selected').val();
        if (selected_loc != '') {
            locations_filter = JSON.parse(selected_loc);
        }

        var educations_filter:any = [];
        var selected_edu:any = $('#education_selected').val();
        if (selected_edu != '') {
            educations_filter = JSON.parse(selected_edu);
        }

        var jobtypes_filter:any = [];
        var selected_types:any = $('#jobtype_selected').val();
        if (selected_types != '') {
            jobtypes_filter = JSON.parse(selected_types);
        }

if($('#created_range').val() == 'custom'){
  var fdatepick:any = $('#from_datepic').val();
  var tdatepick:any = $('#to_datepic').val();
    var range_from = new Date(fdatepick);
    var range_to = new Date(tdatepick);
}
else {
  var fromdatepick:any = $('#from_date').val();
  var todatepick:any = $('#to_date').val();
  var range_from = new Date(fromdatepick);
  var range_to = new Date(todatepick);
}

var fmonth = ("0" + (range_from.getMonth() + 1)).slice(-2);
var fdate = ("0" + range_from.getDate()).slice(-2);
var fyear = range_from.getFullYear();
var from = fyear+'-'+fmonth+'-'+fdate;

var tmonth = ("0" + (range_to.getMonth() + 1)).slice(-2);
var tdate = ("0" + range_to.getDate()).slice(-2);
var tyear = range_to.getFullYear();
var to = tyear+'-'+tmonth+'-'+tdate;

if(new Date(range_from) > new Date(range_to)){
  $("#dateValidMsg").show();
  $(window).scrollTop($('#dateValidMsg').position().top);
  validateEditorTxt = 0;
}else{
  $("#dateValidMsg").hide();
}

if(validateEditorTxt == 0){
  return false;
 }

 console.log(status_filter);
 setReportRangeFrom(fmonth+'/'+fdate+'/'+fyear);
 setReportRangeTo(tmonth+'/'+tdate+'/'+tyear);
 //setReportStatus($('#status_selfilter').val());
 //setReportIndustry($('#industry_selfilter').val());
 //setReportLocation($('#location_selfilter').val());
 //setReportJobtype($('#jobtype_selfilter').val());
 //setReportEducation($('#education_selfilter').val());
 //setReportCareer($('#Career_selfilter').val());
 setRunReport(1);

        const requestObject = {
          "jobCategory": industries_filter,
          "jobLocation": locations_filter,
          "jobEducation": educations_filter,
          "jobType": jobtypes_filter,
          "pageSize": ITEMS_PER_PAGE,
          "pageNumber": pageNumber,
          "sortBy": "createdOn",
          "sortDir": "asc",
          "siteId": 2,
          "searchTxt":$('#job_title').val(),
          "jobStatus":status_filter,
          "careerLevel":career_filter,
          "fromDate" : from,
          "toDate" : to

        }

        var accessTokenIn = sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': "Bearer "+accessTokenIn
            //'Authorization': accessTokenIn
          },
          body: JSON.stringify(requestObject)
        };
        $(".load-wrap").show();
        services.getJobReportList(requestOptions).then((res) => {
          console.log(JSON.stringify(res.content))
          if (res) {
                setTotalItems(res.totalElements);
                settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));
                setCurrentPage(pageNumber);

                var contAr = res.content;
                if(res){
                  setJobFilterList(res.content);
                }
                $(".load-wrap").hide();
           }

        });
}

function getJobDetailsurl(jobid){
  var url_temp = process.env.React_App_FRONT_URL+"jobsummary?jobId="+jobid;
 // var encodeUrl = encodeURIComponent(url_temp);
/*

  var encodeUrl = encodeURIComponent(url_temp);
  setJobShareURL(encodeUrl);
  return encodeUrl; */
  return 1;
}

      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Jobs Report'})}</PageTitle>


        <div >

      {/* begin::Body */}
      <div>
        {/* begin::Table container */}
        <div className='table-responsive ofx-hidden'>


        <form onSubmit={handleSubmit(submitValue)}>
        <div>
          <div className="row">
          <div className="col-lg-12 d-none">
              <div className="mb-10">
              <div className="d-flex justify-content-end">
                    <button type="button" onClick={filterContent_full} className="btn btn-primary my-2" style={{ minWidth: "160px" }}> Export to Excel</button>
                  </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Report Period</label>

                </div>
                <select className="form-select" id="created_range" name="created_range" onChange={set_daterange} aria-label="Select example" >
                  <option selected value='1'>Last 30 Days</option>
                  <option value="3">Last 90 Days</option>
                  <option value="6">Last 180 Days</option>
                  <option value="12">Last 365 Days</option>
                  <option value="custom">Custom</option>
                </select>

              </div>
            </div>

            <div className="col-lg-4 readonly">
              <div className="mb-10 position-relative">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Date From</label>

                </div>
                <input type="text" id="from_date" name="from_date" className="form-control" placeholder="From Date"  disabled/>

                <div id="datepick_from">

                    <DatePicker className="form-control react-date-picker eventStartDateCls"
                                selected={rangeFromDate}
                                onChange={(date) => setFromDate(date)}
                                maxDate={moment().toDate()}
                              id="from_datepic" name="from_datepic"
                              />
                        <div onClick={triggerdateclick} style={{position: "absolute", right: "10px", top: "36px"}}>
                        <KTSVG path='/media/icons/duotune/art/date-icon.svg' />
                        </div>
                </div>
<input type="hidden" id="rangefromhid" />

              </div>
            </div>

            <div className="col-lg-4">
              <div className="mb-10 position-relative">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Date To</label>

                </div>
                <input type="text" id="to_date" name="to_date" className="form-control" placeholder="To Date"  disabled/>

                <div id="datepick_to">

                    <DatePicker className="form-control react-date-picker eventStartDateCls"
                                selected={rangeToDate}
                                onChange={(date) => setToDate(date)}
                                maxDate={moment().toDate()}
                              id="to_datepic" name="to_datepic"
                              />
                        <div onClick={triggerdateclick_to} style={{position: "absolute", right: "10px", top: "36px"}}>
                        <KTSVG path='/media/icons/duotune/art/date-icon.svg' />
                        </div>
                </div>
                <input type="hidden" id="rangetohid" />
                <div id="dateValidMsg" style={{ color: red }} className="error">To Date should not be less than From Date.</div>
              </div>
            </div>

            <div className="col-lg-12 d-none">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Keyword Search</label>

                </div>
                <input type="text" id="job_title" name="job_title" className="form-control" placeholder="Search by Company Name/ Job Title/ Job Summary"  />
              </div>
            </div>



            <div className="col-lg-4">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Status</label>

                </div>
                <input type="hidden" id="status_selected" />
                <input type="hidden" id="status_selfilter" />
                <ReactSelect
                      //className="form-select"
                      options={mulstatus_d}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                          Option
                      }}
                      onChange={handleChangeForstat_d}
                     // allowSelectAll={false}
                      value={optionStatSelected_d}
                  />

              </div>
            </div>

            <div className="col-lg-4">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Industry Category</label>

                </div>
                <input type="hidden" id="industry_selected" />
                <input type="hidden" id="industry_selfilter" />
                <ReactSelect
                      //className="form-select"
                      options={mulcategories_d}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                          Option
                      }}
                      onChange={handleChangeForCate_d}
                     // allowSelectAll={false}
                      value={optionCatSelected_d}
                      defaultValue={['1']}
                  />

              </div>
            </div>

            <div className="col-lg-4">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">County</label>

                </div>
                <input type="hidden" id="location_selected" />
                <input type="hidden" id="location_selfilter" />
                <ReactSelect
                     // className="form-select"
                      options={mullocationCounty}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                          Option
                      }}
                      onChange={handleChangeForLocation_d}
                      //allowSelectAll={false}
                      value={mullocationCountyselected_d}
                  />

              </div>
            </div>

            <div className="col-lg-4">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Type</label>

                </div>
                <ReactSelect
                       // className="form-select"
                        options={muljobTypes}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                            Option
                        }}
                        onChange={handleChange_d}
                        //allowSelectAll={true}
                        value={optionSelected_d}
                    />
                    <input type="hidden" id="jobtype_selected" />
                    <input type="hidden" id="jobtype_selfilter" />

              </div>
            </div>

            <div className="col-lg-4">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Education</label>

                </div>
                <input type="hidden" id="education_selected" />
                <input type="hidden" id="education_selfilter" />
                <ReactSelect
                       // className="form-select"
                        options={muleducation}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                            Option
                        }}
                        onChange={handleChangeForEdu_d}
                        //allowSelectAll={true}
                        value={optionEducationSelected_d}
                    />
              </div>
            </div>

            <div className="col-lg-4">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Career Level</label>

                </div>
                <input type="hidden" id="career_selected" />
                <input type="hidden" id="Career_selfilter" />
                <ReactSelect
                      //className="form-select"
                      options={mulcareer_d}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                          Option
                      }}
                      onChange={handleChangeForcareer_d}
                     // allowSelectAll={false}
                      value={optionCareerSelected_d}
                  />
              </div>
            </div>


            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <div className="d-block">
                    <button type="submit" className="btn btn-primary ml-2 mb-10" style={{ minWidth: "130px" }}>Run Report </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </form>


          {/* begin::Table */}
          <div className="card">
            <div className="card-body px-2 pt-0">

           <div className="d-flex justify-content-end text-right">
           <div className={runReport == 1 ? "tag-wrp" : "tag-wrp d-none"}>
                <div className={reportRangeFrom != '' ? "tag-inn" : ''}><label>{reportRangeFrom != '' ? 'Report Range From : ' : ''}</label>{reportRangeFrom != '' ? reportRangeFrom : ''}  <label>{reportRangeFrom != '' ? 'To : ' : ''}</label>{reportRangeTo != '' ? reportRangeTo : ''}</div>

                <div className={reportStatus != '' ? "tag-inn" : ''}><label>{reportStatus != '' ? 'Status : ' : '' }</label>{reportStatus != '' ? reportStatus : '' }</div>

                <div className={reportIndustry != '' ? "tag-inn" : ''}><label>{reportIndustry != '' ? 'Industry : ' : '' }</label>{reportIndustry != '' ? reportIndustry : '' }</div>

                <div className={reportLocation != '' ? "tag-inn" : ''}><label>{reportLocation != '' ? 'County : ' : '' }</label>{reportLocation != '' ? reportLocation : '' }</div>

                <div className={reportJobtype != '' ? "tag-inn" : ''}><label>{reportJobtype != '' ? 'Type : ' : '' }</label>{reportJobtype != '' ? reportJobtype : '' }</div>

                <div className={reportEducation != '' ? "tag-inn" : ''}><label>{reportEducation != '' ? 'Education : ' : '' }</label>{reportEducation != '' ? reportEducation : '' }</div>

                <div className={reportCareer != '' ? "tag-inn" : ''}><label>{reportCareer != '' ? 'Career : ' : '' }</label>{reportCareer != '' ? reportCareer : '' }</div>
            </div>
           <button type="button" onClick={filterContent_full} className="btn btn-primary my-2 align-self-center" style={{ minWidth: "160px", marginLeft:"auto" }}> Export to Excel</button>
           </div>
           <div className="new-scrl-tbl">
            <div className="dummy" style={{minWidth:"2000px"}}></div>
           </div>
              <div className="new-scrl-tbl2">
                <div className="dummy2">
            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 wid'>
            {/* begin::Table head */}
            <thead>


              <tr className='fw-bolder text-muted report-tbl'>
                
                <th>Title</th>
                <th>Company</th>
                <th>Location</th>
                <th>Type</th>
                <th>Posted Date</th>
                <th>Career Leel</th>
                <th>Education Leel</th>
                <th>Status</th>
                <th>Job URL</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>

            {
	          jobfilterlist.map((data, index) => (
              <tr className="fw-bolder">
                <td style={{minWidth:"200px",verticalAlign:"baseline"}}>{data.jobTitle}</td>
                <td style={{minWidth:"300px",verticalAlign:"baseline"}}>{data.companyName}</td>
                <td style={{minWidth:"150px",verticalAlign:"baseline"}}>{data.city+', '+data.state}</td>
                <td style={{minWidth:"150px",verticalAlign:"baseline"}}>{data.jobTypeName}</td>
                <td style={{minWidth:"130px", verticalAlign:"baseline"}}>{(data.createdDate=='' || data.createdDate==null) ? '--' : moment(data.createdDate).utcOffset('-0400').format("MM/DD/YYYY, HH:mm:ss")}</td>
                <td style={{minWidth:"200px",verticalAlign:"baseline"}}>{data.career}</td>
                <td style={{minWidth:"200px",verticalAlign:"baseline"}}>{data.educationName}</td>
                <td style={{maxWidth:"100px",verticalAlign:"baseline"}}>{data.status}</td>
                {data.status == 'published' ?
                  <td style={{minWidth:"300px",verticalAlign:"baseline", wordBreak:"break-all"}}><a href={process.env.React_App_PUBLIC_URL+"jobsummary?jobId="+data.jobId} target="_blank">{process.env.React_App_PUBLIC_URL+"jobsummary?jobId="+data.jobId}</a></td>
                : <td style={{minWidth:"100px",verticalAlign:"baseline", textAlign:"center"}}>--</td>}
              </tr>
              ))}

            </tbody>
            {/* end::Table body */}
          </table>
          </div></div>
               {/* end::Table */}

              <span className="mb-2 d-block"></span>
          <Pagination

total={totalItems}
itemsPerPage={ITEMS_PER_PAGE}
currentPage={currentPage}
onPageChange={handlePageChange2}

/>

            </div>
          </div>
        </div>
        {/* end::Table container */}
      </div>
      <section className="load-wrap">
          <div className="loadingIcon">
            <img src="/media/icons/duotune/general/loading.gif" className="m-auto"></img>
            <span>Loading... <br /> please be patient..</span>
             </div>
        </section>
      {/* begin::Body */}
    </div>



        </>
      )
    }
export {JobsReport}